export default {
	namespaced:true,
	actions:{
        
	},
	mutations:{
        
	},
	state:{
		imgs:[
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/CSF/CSF_0_00.png',
		],
        //过程数据
        progressData:[],
        result:null
	},
	getters:{
        
	},
}